import { useRef } from "react";
import {
  Button,
  Typography,
  Box,
  styled,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import ToastSnackbar, { SnackbarHandle } from "../../common/ToastNotification";
import HomeIcon from "@mui/icons-material/Home";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import React, { useEffect, useState } from "react";
import { Get as GetClass } from "../../api/Control-Settings/manage-class";
import { GetSections } from "../../api/Exams-Management/manage-section";
import { useForm } from "react-hook-form";
import ControlledSelect from "../../common/ControlledComponents/ControlledSelect";
import FeeDueMonthly from "../../templates/feeDueMonthly";
import { useReactToPrint } from "react-to-print";
// import { GetCurrentAcademciSession } from "../../helper/helper";
import { GetFeeDuesReport } from "../../api/Report-Center/fee-collection";
import { useApi } from "../../store/UserLoginContext";

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#2e186a",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "0rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

const months = [
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
];

const FeeDues = () => {
  const { currentSessionAY } = useApi();
  const snackbarRef = React.useRef<SnackbarHandle>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [sectionList, setSectionList] = useState<any>([]);
  const [classRecords, setClassRecords] = useState<any>([]);
  const [adding, setAdding] = useState(false);
  const [printData, setPrintData] = useState<any>([]);
  const [readyToPrint, setReadyToPrint] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [classes_records, section_records] = await Promise.all([
          GetClass(),
          GetSections(),
        ]);

        if (classes_records && classes_records.result.documents?.length > 0) {
          setClassRecords(classes_records.result.documents);
        }
        if (section_records && section_records.result.documents?.length > 0) {
          setSectionList(section_records.result.documents);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        snackbarRef.current?.showSnackbar(`Error fetching data`, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const {
    handleSubmit,
    control,
    formState: { errors },
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      class_id: "",
      section_id: "",
      month: "",
    },
    mode: "onTouched",
  });

  const handlePrint = useReactToPrint({
    documentTitle: "",
    onAfterPrint: () => setReadyToPrint(false),
  }) as (content: () => HTMLElement | null) => () => void;

  const handleFormSubmit = async (data: any) => {
    try {
      setAdding(true);
      console.log("Logic to fetch dues report", data);

      const curr_session = currentSessionAY || null; //GetCurrentAcademciSession();

      if (!curr_session) {
        snackbarRef.current?.showSnackbar(`Academic Session Error.`, "error");
        return;
      }

      const payload = {
        class_id: data.class_id,
        section_id: data.section_id,
        inputMonthStr: data.month.concat(`-${curr_session.split("-")[0]}`),
        academic_year: currentSessionAY,
      };

      // console.log("Payload to get the data for fee due report monthly");
      // console.log(payload);

      const response = await GetFeeDuesReport(payload);

      console.log(response);

      if (response.length === 0) {
        snackbarRef.current?.showSnackbar(`No Records found`, "error");
        return;
      }
      // creatin sample data for fee due report
      console.log(classRecords);
      const class_name = classRecords.find(
        (el: any) => el.class_id === data.class_id
      ).name;
      const section_name = sectionList.find(
        (el: any) => el.section_id === data.section_id
      ).name;

      let payload_for_print: any = [];
      payload_for_print = [...response.Students_Details];
      payload_for_print[0].class_name = class_name;
      payload_for_print[0].section_name = section_name;

      setPrintData(payload_for_print);
      setReadyToPrint(true);

      setTimeout(() => {
        try {
          handlePrint(() => containerRef.current!)();
        } catch (error) {
          console.log("Handling print function call error.");
          console.log(error);
        }
      }, 400);
    } catch (error) {
      console.log(error);
      snackbarRef.current?.showSnackbar(`Some Error occured`, "error");
    } finally {
      setAdding(false);
    }
  };

  const onResetHandler = () => {
    reset({
      class_id: "",
      section_id: "",
    });
  };

  return (
    <>
      <ToastSnackbar ref={snackbarRef} />
      {readyToPrint && (
        <div
          style={{
            position: "absolute",
            left: "-9999px",
            top: "0",
          }}
        >
          {/* @ts-ignore */}
          <FeeDueMonthly ref={containerRef} feeDueData={printData} />
        </div>
      )}
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        p={2}
        pb={0}
        gap={1}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-start"}
          p={2}
          pb={0}
          gap={1}
        >
          <MyCustomButton
            variant="contained"
            startIcon={<ArrowLeftIcon />}
            onClick={() => navigate("..")}
          >
            Go Back
          </MyCustomButton>
          <MyCustomButton
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate("/home")}
          >
            Home
          </MyCustomButton>
        </Box>
      </Box>

      <Box
        display={"flex"}
        flexDirection={"column"}
        p={2}
        pt={0}
        height="auto"
        width="auto"
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          p={2}
          pt={0}
          height="auto"
          justifyContent={"center"}
          alignItems={"center"}
          width={"90vw"}
        >
          <Typography variant="h6" alignSelf={"center"}>
            <strong>Select Class And Section To Fetch Fee Due Report</strong>
          </Typography>
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-evenly"}
            gap={3}
            width="auto"
            mt={4}
          >
            {loading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100px"
              >
                <CircularProgress />
              </Box>
            ) : (
              <form
                onSubmit={handleSubmit(handleFormSubmit)}
                onReset={onResetHandler}
              >
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-evenly"}
                  gap={3}
                  width="70vw"
                >
                  <ControlledSelect
                    name={`class_id`}
                    control={control}
                    errors={errors}
                    label="Class"
                    rules={{ required: "Required" }}
                    options={classRecords.map((item: any) => ({
                      value: item.class_id,
                      label: item.name,
                    }))}
                    sx={{ width: "30%" }}
                    // selectProps={{ onChange: HandleClassChange }}
                  />
                  <ControlledSelect
                    name={`section_id`}
                    control={control}
                    errors={errors}
                    label="Section"
                    rules={{ required: "Required" }}
                    options={sectionList.map((item: any) => ({
                      value: item.section_id,
                      label: item.name,
                    }))}
                    sx={{ width: "30%" }}
                    // selectProps={{ onChange: HandleClassChange }}
                  />
                  <ControlledSelect
                    name={`month`}
                    control={control}
                    errors={errors}
                    label="Month"
                    rules={{ required: "Required" }}
                    options={months.map((item: any) => ({
                      value: item.value,
                      label: item.label,
                    }))}
                    sx={{ width: "30%" }}
                    // selectProps={{ onChange: HandleClassChange }}
                  />

                  <MyCustomButton
                    variant="contained"
                    type="submit"
                    startIcon={adding ? <CircularProgress size={20} /> : null}
                    disabled={adding}
                    sx={{
                      alignSelf: "center",
                      height: "70%",
                      width: "20%",
                    }}
                  >
                    {adding ? "" : "Fetch Report"}
                  </MyCustomButton>
                  <MyCustomButton
                    variant="contained"
                    type="reset"
                    sx={{
                      alignSelf: "center",
                      height: "70%",
                      width: "20%",
                    }}
                  >
                    Clear
                  </MyCustomButton>
                </Box>
              </form>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default FeeDues;
